/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable  no-useless-escape */

import React, { useEffect, useMemo, useRef, useState } from 'react';
import { CheckBox, CustomInput, SelectDropDown, useAppDispatch, useAppSelector, useEffectOnce } from '../../../globalUtils/globalExports';
import { cloneDeep, isInteger } from 'lodash';
import CustomDropDown, { ISelectOption } from './CustomDropDown';
import { clearDerivedConditionFormRedux, fetchAdvanceRuleEngineArithmeticOperatorsReferenceData, fetchAdvanceRuleEngineConnectivesReferenceData, fetchAdvanceRuleEngineRelationalOperatorReferenceData, fetchDerivedCondition, getReferenceDataReducer } from '../../../rmsReduxStore/reduxExports';
import { fetchAdvanceRuleEngineTriggerParameterReferenceData } from '../../../rmsReduxStore/reduxExports';
import { checkValidDecimal, checkValidInteger } from './ExecutionPlan';
import { Icon, IconWithTooltip } from '../../../globalUtils/globalIcons';
import { useNavigate } from 'react-router-dom';
import './CustomTriggerConditionComponent.css';
import CustomChartPopup from '../../softwareReleaseManagement/dashboard/CustomChartPopup';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export type LogicalOperators = 'AND' | 'OR';
export type ConnectorType = 'ac' | 'dc';
export type ConnectorScope = 'any' | 'all';

export interface ICustomTriggerCondition {
    triggerCondName: string;

    triggerParamId: string | null;
    triggerParamLabel: string | null;
    triggerParamType: string | null;
    triggerParamLevel: string | null;
    triggerOperator: string | null;
    triggerParameter1Value: number | string | null;
    triggerParameter2Value: number | string | null;
    isTriggerParamTypeEnum: boolean;
    triggerParamEnumValue: string[];
    triggerParamUnit: string | null;
    isTriggerParamTypeDate: boolean;
    isDerived: boolean;

    connectorType: ConnectorType | null;
    connectorScope: ConnectorScope | null;

    arithmeticParamId: string | null;
    arithmeticParamLabel: string | null;
    arithmeticParamType: string | null;
    arithmeticParamLevel: string | null;
    arithmeticOperator: string | null;
    arithmeticParamValue: number | null;
    arithmeticParamUnit: string | null;
    arithmeticParamConnectorType: ConnectorType | null;

    connective: LogicalOperators | null;

    errorMessage: string | null;
    errorMessageSecondary: string | null;
    errorMessageArithmeticParam: string | null;
}

interface ICustomTriggerConditionComponentProps {
    condition: ICustomTriggerCondition;
    handleConditionUpdate: (conditionLabel: string, condition: ICustomTriggerCondition) => void;
    position: number;
    showSessionNote: boolean;
}


export type ParameterType = 'STATUS' | 'SETTING' | 'ALARMS' | 'SYSTEM_INFO' | 'SESSION' | 'DERIVED';

export const parseOptionValues = (values: string | null,number_key: string) => {
        if (!values) return [];
        // These are the keys (eg:last stop reason) for which code is added in the value which need to be removed from id and value.
        const special_keys = new Set(['1.5.1.4.8.11','1.5.1.4.3','1.5.1.3.8','1.5.1.3.13.18']);
        const parsedJson = JSON.parse(values);
        const options: IGeneralReferenceData[] = [];
        for (const key in parsedJson) {
            const label = parsedJson[key];
            const value = special_keys.has(number_key) ? label?.replace(/\(\d+\)$/, '') : label;
            options.push({ id: value, label: label, name: label, value });
        }
        return options
    }

const CustomTriggerConditionComponent: React.FC<ICustomTriggerConditionComponentProps> = ({ condition, handleConditionUpdate,position,showSessionNote }) => {

    const parameterTypeList = [
        {
            id: 'STATUS',
            name: 'Status Parameter',
            label: 'Status Parameter',
            icon: 'rms__advance__rule__engine__status__icon'
        },
        {
            id: 'SETTING',
            name: 'Setting Parameter',
            label: 'Setting Parameter',
            icon: 'rms__advance__rule__engine__setting__icon'
        },
        {
            id: 'ALARMS',
            name: 'Alarms',
            label: 'Alarms',
            icon: 'rms__advance__rule__engine__alarm__icon'
        },
        {
            id: 'SYSTEM_INFO',
            name: 'System Info Parameter',
            label: 'System Info Parameter',
            icon: 'rms__advance__rule__engine__system__info__icon'
        },
        {
            id: 'SESSION',
            name: 'Session Parameter',
            label: 'Session Parameter',
            icon: 'rms__advance__rule__engine__session__icon'
        },
        {
            id: 'DERIVED',
            name: 'Derived Conditions',
            label: 'Derived Conditions',
            icon: 'rms__advance__rule__engine__status__icon'
        }
    ]

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const {advanceRuleEngineTriggerParameterReferenceData,advanceRuleEngineArithmeticOperatorReferenceData,advanceRuleEngineConnectivesReferenceData,advanceRuleEngineRelationalOperatorReferenceData} = useAppSelector(getReferenceDataReducer);
    const parameterTypeValue = parameterTypeList?.filter(item => item?.id === condition?.triggerParamType);
    const arithmeticParamTypeValue = parameterTypeList?.filter(item => item?.id === condition?.arithmeticParamType);
    const [selectedParameters, setSelectedParameters] = useState<ISelectOption | null>(condition?.triggerParamType ? parameterTypeValue?.[0] : parameterTypeList?.[0]);
    const [arithmeticParamType, setArithmeticParamType] = useState<ISelectOption | null>(condition?.arithmeticParamType ? arithmeticParamTypeValue?.[0] : parameterTypeList?.[0]);
    const [enableArithmeticLogic, setEnableArtihmeticLogic] = useState<boolean>(condition?.arithmeticParamId ? true : false);
    const [selectedTriggerParameter, setSelectedTriggerParameter] = useState<IAdvanceRuleEngineTriggerParameterReferenceData | null>(null);
    const [selectedArithmeticParameter, setSelectedArtihmeticParameter] = useState<IAdvanceRuleEngineTriggerParameterReferenceData | null>(null);
    const parameterRef = useRef<IAdvanceRuleEngineTriggerParameterReferenceData[] | null>(null);
    parameterRef.current = advanceRuleEngineTriggerParameterReferenceData;
    const derivedConditionImageUrlRef = useRef<string | undefined>(undefined);
    const [showImage,setShowImage] = useState<boolean>(false);


    useEffectOnce(() => {
        dispatch(fetchAdvanceRuleEngineTriggerParameterReferenceData());
        dispatch(fetchAdvanceRuleEngineArithmeticOperatorsReferenceData());
        dispatch(fetchAdvanceRuleEngineRelationalOperatorReferenceData());
        dispatch(fetchAdvanceRuleEngineConnectivesReferenceData());
    })

    useEffect(()=>{
        if(advanceRuleEngineArithmeticOperatorReferenceData) {
            parameterRef.current = advanceRuleEngineTriggerParameterReferenceData;
            
            const triggerParamValue = parameterRef?.current?.filter(item => item?.parameterKey === condition?.triggerParamId && (item?.acOrDcParam ?? '')?.toLowerCase() === (condition?.connectorType ?? '')?.toLowerCase());
            if(triggerParamValue?.[0]) setSelectedTriggerParameter(triggerParamValue?.[0]);

            const arithmeticParamValue = parameterRef?.current?.filter(item => item?.parameterKey === condition?.arithmeticParamId && (item?.acOrDcParam ?? '')?.toLowerCase() === (condition?.arithmeticParamConnectorType ?? '')?.toLowerCase());
            if(arithmeticParamValue?.[0]) setSelectedArtihmeticParameter(arithmeticParamValue?.[0]);
        }
    },[advanceRuleEngineTriggerParameterReferenceData])

    const isBlockedCharacters = (val) => ['e','E','+','-','.']?.includes(val);

    const isEnumType = (fieldType: string | null) => {
        if (!fieldType) return false;
        return fieldType === 'DropDownSingle' || fieldType === 'DropDownMultiple' || fieldType === 'Toggle';
    }

    const getFieldType = (dataType: string | null) => {
        if(dataType === 'Date')return 'date';
        if(dataType === 'String') return 'text';
        return 'number';
    }

    const relationalOperators = useMemo(() => advanceRuleEngineRelationalOperatorReferenceData?.filter(item=>item?.id!=='is' && item?.id!=='isNot') ?? [],[advanceRuleEngineRelationalOperatorReferenceData]);
    const relationalOperatorsForEnum = useMemo(() => advanceRuleEngineRelationalOperatorReferenceData?.filter(item=>item?.id==='is' || item?.id==='isNot') ?? [],[advanceRuleEngineRelationalOperatorReferenceData]);
    const arithmeticOperators = useMemo(() => advanceRuleEngineArithmeticOperatorReferenceData ?? [],[advanceRuleEngineArithmeticOperatorReferenceData]);
    const connectives = useMemo(() => advanceRuleEngineConnectivesReferenceData ?? [],[advanceRuleEngineConnectivesReferenceData]);

    const checkValidationAndShowError = (key: string, value: string, param: IAdvanceRuleEngineTriggerParameterReferenceData): string | null => {
        const parsedValues = param?.possibleValue ? JSON.parse(param?.possibleValue) : null;
        if (param?.dataType === 'Integer') {
            if (!checkValidInteger(value)) return 'Enter a valid Integer value';
            if (key === 'triggerParameter2Value' && parseInt(value) <= parseInt(condition?.triggerParameter1Value as string)) {
                return 'The second value must be greater than the first value';
            }

            if(parsedValues && !(parseInt(value) >= parsedValues['min'] && parseInt(value) <= parsedValues['max'])){
                return `Please enter a value between ${parsedValues['min']} and ${parsedValues['max']}.`;
            }

        }
        if (param?.dataType === 'Double') {
            if (!checkValidDecimal(value)) return 'Enter a valid Double value';
            if (key === 'triggerParameter2Value' && parseFloat(value) <= parseFloat(condition?.triggerParameter1Value as string)) {
                return 'The second value must be greater than the first value';
            }

            if(parsedValues && !(parseFloat(value) >= parsedValues['min'] && parseFloat(value) <= parsedValues['max'])){
                return `Please enter a value between ${parsedValues['min']} and ${parsedValues['max']}.`;
            }

        }
        return null;
    }

    const toggleArithmeticCondition = (val: boolean) => {
        const data = cloneDeep(condition);
        if (!val) {
            data.arithmeticParamId = null;
            data.arithmeticParamLabel = null;
            data.arithmeticParamLevel = null;
            data.arithmeticParamType = null;
            data.arithmeticParamValue = null;
            data.arithmeticOperator = null;
            data.arithmeticParamConnectorType = null;
            data.errorMessageArithmeticParam = null;

            setSelectedArtihmeticParameter(null);
        }
        else {
            if (data.triggerOperator === 'between' || data.triggerOperator === 'notBetween') {
                data.triggerOperator = null;
            }
            data.triggerParameter1Value = null;
            data.triggerParameter2Value = null;
        }
        handleConditionUpdate(data.triggerCondName, data);
        setEnableArtihmeticLogic(val);
    }

    const onViewDerivedConditionClick = (conditionId) => {
        if(!conditionId)return;
        dispatch(fetchDerivedCondition({id:conditionId})).then(data=>{
            derivedConditionImageUrlRef.current = data?.imageURL;
            setShowImage(true);
        })
    }

    return (
        <>
        <div className='advance__rule__engine__trigger__condition__container' key={condition?.triggerCondName}>
            {
                position > 0  && <div className='advance__rule__engine__trigger__connective__container'>
                    <SelectDropDown 
                        selectValue={connectives?.filter(item => item?.id === condition?.connective)?.[0]}
                        selectDropDownId={'advance__rule__engine__trigger__connective-dropdown'} 
                        handleSelectOptionChange={ (value) => {
                            const data = cloneDeep(condition);
                            data.connective = value?.id;
                            handleConditionUpdate(data?.triggerCondName,data);
                        }} 
                        selectOptions={connectives}                
                    />
                </div>
            }
            <div className='advance__rule__engine__trigger__condition__container-header'>
                <div className='advance__rule__engine__trigger__condition-info'>
                    <div className='advance__rule__engine__trigger__condition-label'>
                        {condition?.triggerCondName}
                    </div>
                    <div className='advance__rule__engine__trigger__condition-label-description'>
                        <div className='advance__rule__engine__trigger__condition-label-description-top'>Condition {condition?.triggerCondName}</div>
                        <div className='advance__rule__engine__trigger__condition-label-description-bottom'>Define the statement</div>
                    </div>
                </div>
                <div className='advance__rule__engine__trigger__condition-parameter-type-selection'>
                    <CustomDropDown
                        selectDropDownId='advance_rule_engine-parameter-type-selection-dropdown'
                        dropDownClassName='advance__rule__engine__parameter-type-selection-dropdown'
                        selectedValue={selectedParameters}
                        handleSelectOptionChange={(value) => {
                            if (value?.id !== selectedParameters?.id) {
                                setSelectedTriggerParameter(null);
                                const data = {
                                    triggerCondName: condition?.triggerCondName,

                                    triggerParamId: null,
                                    triggerParamLabel: null,
                                    triggerParamType: null,
                                    triggerParamLevel: null,
                                    triggerOperator: null,
                                    triggerParameter1Value: null,
                                    triggerParameter2Value: null,
                                    isTriggerParamTypeEnum: false,
                                    triggerParamEnumValue: [],
                                    triggerParamUnit: null,
                                    isTriggerParamTypeDate: false,
                                    isDerived: value?.id === 'DERIVED',
                                    
                                    connectorType: null,
                                    connectorScope: null,


                                    arithmeticParamId: null,
                                    arithmeticParamLabel: null,
                                    arithmeticParamType: null,
                                    arithmeticParamLevel: null,
                                    arithmeticOperator: null,
                                    arithmeticParamValue: null,
                                    arithmeticParamUnit: null,
                                    arithmeticParamConnectorType: null,

                                    connective: condition?.connective,

                                    errorMessage: null,
                                    errorMessageSecondary: null,
                                    errorMessageArithmeticParam: null
                                }
                                handleConditionUpdate(data?.triggerCondName, data);
                            }
                            setSelectedParameters(value)
                            setSelectedTriggerParameter(null);
                            setArithmeticParamType(parameterTypeList?.[0]);
                            setEnableArtihmeticLogic(false);
                            setSelectedArtihmeticParameter(null);
                        }}
                        selectOptions={parameterTypeList}
                        renderToBody={true}
                    />
                </div>
            </div>
            <div className='advance__rule__engine__trigger__condition__container-body'>
                {
                    !condition?.isDerived && <div className='advance__rule__engine__trigger__condition__container-body-header'>
                        <div className='advance__rule__engine__trigger__condition__container-body-header-col1'>Parameter*</div>
                        <div className='advance__rule__engine__trigger__condition__container-body-header-col2'>Operator*</div>
                        <div className='advance__rule__engine__trigger__condition__container-body-header-col3'>Value*</div>
                    </div>
                }
                <div className='advance__rule__engine__trigger__condition__body-container'>
                    <div className={condition?.isDerived ? 'advance__rule__engine__trigger__condition-parameter-derived' : 'advance__rule__engine__trigger__condition-parameter'}>
                        <div className={condition?.isDerived ? 'advance__rule__engine__derived-parameter-label' : 'derived_condition_hide-label' }>
                            Derived Condition
                        </div>
                        <SelectDropDown
                            selectDropDownId='advance_rule_engine-trigger-parameter-selection-dropdown'
                            dropDownClassName={'advance_rule_engine-trigger-parameter-selection-dropdown'}
                            selectValue={selectedTriggerParameter}
                            handleSelectOptionChange={(value) => {
                                const data = cloneDeep(condition);
                                data.triggerParamId = value?.parameterKey;
                                data.triggerParamLabel = value?.label;
                                data.triggerParamType = value?.parameterType;
                                data.triggerParamLevel = value?.parameterLevel;
                                data.isTriggerParamTypeEnum = isEnumType(value?.fieldType)
                                data.isTriggerParamTypeDate = getFieldType(value?.dataType) === 'date';
                                data.isDerived = value?.parameterType === 'DERIVED';
                                data.connectorType = value?.parameterLevel === 'CONNECTOR' ? value?.acOrDcParam : null;
                                data.connectorScope = value?.parameterLevel === 'CONNECTOR' ? 'any' : null;
                                data.triggerParamUnit = value?.unit && value?.unit != 'NA' ? value.unit : null;
                                if (data.isTriggerParamTypeEnum || data.isTriggerParamTypeDate) toggleArithmeticCondition(false);
                                if(value?.dataType !== selectedTriggerParameter?.dataType || value?.fieldType !== selectedTriggerParameter?.fieldType){
                                    data.triggerOperator = null;
                                    data.triggerParameter1Value = null;
                                    data.triggerParameter2Value = null;
                                }
                                data.errorMessage = null;
                                data.errorMessageSecondary = null;
                                handleConditionUpdate(data?.triggerCondName, data);
                                setSelectedTriggerParameter(value);

                            }}
                            selectOptions={parameterRef?.current?.filter(item => item?.parameterType === selectedParameters?.id) ?? []}
                            renderToBody={true}
                        />
                        <div className={condition?.isDerived ? 'advance__rule__engine__derived-parameter-view-icon' : 'derived_condition_hide-label'}>
                            <Icon iconClassName='advance__rule__engine__view__derived__condition__icon' onIconClick={()=>onViewDerivedConditionClick(condition?.triggerParamId)}/>
                        </div>
                    </div>
                    {
                        !condition?.isDerived && <div className='advance__rule__engine__trigger__condition-operator'>
                            <SelectDropDown
                                selectDropDownId='advance_rule_engine-trigger-operator-selection-dropdown'
                                selectValue={(selectedTriggerParameter && (isEnumType(selectedTriggerParameter.fieldType!) || selectedTriggerParameter?.dataType === 'String') ? relationalOperatorsForEnum?.filter(item => item?.id === condition?.triggerOperator)?.[0] : relationalOperators?.filter(item => item?.id === condition?.triggerOperator)?.[0]) ?? null}
                                handleSelectOptionChange={(value) => {
                                    const data = cloneDeep(condition);
                                    data.triggerOperator = value?.id;
                                    if(value?.id !== 'between' && value?.id !== 'notBetween'){
                                        data.triggerParameter2Value = null;
                                        data.errorMessageSecondary = null;
                                    }
                                    if(condition?.isTriggerParamTypeDate && value?.id !== condition?.triggerOperator){
                                        data.triggerParameter1Value = null;
                                    }
                                    handleConditionUpdate(data?.triggerCondName, data);
                                }}
                                selectOptions={selectedTriggerParameter && (isEnumType(selectedTriggerParameter.fieldType!) || selectedTriggerParameter?.dataType === 'String') ? relationalOperatorsForEnum : enableArithmeticLogic ? relationalOperators?.filter(item => item?.id != 'between' && item?.id != 'notBetween') : relationalOperators}
                                renderToBody={true}
                                isDisabled={!selectedTriggerParameter}
                            />
                        </div>
                    }
                    {
                        !condition?.isDerived && !enableArithmeticLogic && <div className='advance__rule__engine__trigger__condition-value'>
                            {
                                selectedTriggerParameter && isEnumType(selectedTriggerParameter?.fieldType) ?
                                    <SelectDropDown
                                        selectDropDownId={'advance__rule__engine__trigger__condition-value-dropdown'}
                                        selectValue={parseOptionValues(selectedTriggerParameter?.possibleValue,selectedTriggerParameter?.numberKeyFormat)?.filter(item=> condition?.triggerParamEnumValue?.includes(item?.value))}
                                        handleSelectOptionChange={
                                            (values) => {
                                                const data = cloneDeep(condition);
                                                data.triggerParamEnumValue = values?.map(item=>item?.value);
                                                handleConditionUpdate(data?.triggerCondName, data);
                                            }
                                        }
                                        selectOptions={selectedTriggerParameter?.possibleValue ? parseOptionValues(selectedTriggerParameter?.possibleValue,selectedTriggerParameter?.numberKeyFormat) : []}
                                        renderToBody={true}
                                        isMultiSelect={true}
                                    />
                                    :
                                    condition?.triggerOperator && (condition?.triggerOperator === 'between' || condition?.triggerOperator === 'notBetween') ?
                                        <div className='advance__rule__engine__trigger__condition-value-container'>
                                            <CustomInput
                                                inputValue={condition?.triggerParameter1Value ? condition?.triggerParameter1Value : ''}
                                                inputFieldId={'advance__rule__engine__trigger__condition-value-1'}
                                                isRequired={true}
                                                inputType={getFieldType(selectedTriggerParameter?.dataType ?? null)}
                                                isDisabled={!condition?.triggerOperator}
                                                handleInputChange={(event) => {
                                                    const error = checkValidationAndShowError('triggerParameter1Value', event?.target?.value, selectedTriggerParameter!);
                                                    const data = cloneDeep(condition);
                                                    data.errorMessage = error;
                                                    data.triggerParameter1Value = event?.target?.value;
                                                    if (error) data.triggerParameter2Value = null;
                                                    handleConditionUpdate(data?.triggerCondName, data);
                                                }}
                                                errorMessage={condition?.errorMessage}
                                            />
                                            <CustomInput
                                                inputValue={condition?.triggerParameter2Value ? condition?.triggerParameter2Value : ''}
                                                inputFieldId={'advance__rule__engine__trigger__condition-value-2'}
                                                isRequired={true}
                                                inputType={getFieldType(selectedTriggerParameter?.dataType ?? null)}
                                                isDisabled={!condition?.triggerParameter1Value}
                                                handleInputChange={(event) => {
                                                    const error = checkValidationAndShowError('triggerParameter2Value', event?.target?.value, selectedTriggerParameter!);
                                                    const data = cloneDeep(condition);
                                                    data.errorMessageSecondary = error;
                                                    data.triggerParameter2Value = event?.target?.value;
                                                    handleConditionUpdate(data?.triggerCondName, data);
                                                }}
                                                errorMessage={condition?.errorMessageSecondary}
                                            />
                                            {
                                                selectedTriggerParameter?.unit && selectedTriggerParameter?.unit != 'NA' && <div className='advance__rule__engine__trigger__condition-value-unit-container'>
                                                    {selectedTriggerParameter?.unit}
                                                </div>
                                            }
                                        </div>
                                        :
                                        condition?.isTriggerParamTypeDate && condition?.triggerOperator  && (condition?.triggerOperator === 'greaterThan' || condition?.triggerOperator === 'lessThan' || condition?.triggerOperator === 'greaterThanEqualTo' || condition?.triggerOperator === 'lessThanEqualTo') ? 
                                        <div className='advance__rule__engine__custom__condition-date-value-container'>
                                            <div className='advance__rule__engine__custom__condition-value-label'>
                                                <span>Last</span>
                                            </div>
                                            <CustomInput
                                                inputValue={condition?.triggerParameter1Value ? condition?.triggerParameter1Value : ''}
                                                inputFieldId={'advance__rule__engine__trigger__condition-date-value-1'}
                                                containerClassName={'advance__rule__engine__trigger__condition__date__value'}
                                                isRequired={true}
                                                inputType={'number'}
                                                isDisabled={!condition?.triggerOperator}
                                                handleKeyPress={(event)=>{
                                                    if(isBlockedCharacters(event?.key)){
                                                        event.preventDefault();
                                                    }
                                                }}
                                                handleInputChange={(event) => {
                                                    if(!isInteger(Number(event?.target?.value)))return;
                                                    const data = cloneDeep(condition);
                                                    data.triggerParameter1Value = event?.target?.value;
                                                    handleConditionUpdate(data?.triggerCondName, data);
                                                }}
                                                errorMessage={condition?.errorMessage}
                                            />
                                            <div className='advance__rule__engine__custom__condition-value-label'>
                                                <span>days</span>  
                                                <IconWithTooltip
                                                    iconClassName="rms_info_icon-black"
                                                    containerClassName="user__form_footer-auto-assign-info"
                                                    toolTipText={
                                                        <>
                                                            <ul style={{ listStyleType: 'none', margin: 0, paddingLeft: 0 }}>
                                                                <li style={{ marginBottom: '5px' }}>Greater than last x days = Newer in the last x days</li>
                                                                <li style={{ marginBottom: '5px' }}>Less than last x days = Older than x days</li>
                                                            </ul>
                                                        </>
                                                    }
                                                />
                                            </div>
                                        </div>
                                        :
                                        <div className='advance__rule__engine__trigger__condition-value-container'>
                                            <CustomInput
                                                inputValue={condition?.triggerParameter1Value ? condition?.triggerParameter1Value : ''}
                                                inputFieldId={'advance__rule__engine__trigger__condition-value-1'}
                                                isRequired={true}
                                                inputType={getFieldType(selectedTriggerParameter?.dataType ?? null)}
                                                isDisabled={!condition?.triggerOperator}
                                                handleInputChange={(event) => {
                                                    const error = checkValidationAndShowError('triggerParameter1Value', event?.target?.value, selectedTriggerParameter!);
                                                    const data = cloneDeep(condition);
                                                    data.errorMessage = error;
                                                    data.triggerParameter1Value = event?.target?.value;
                                                    handleConditionUpdate(data?.triggerCondName, data);
                                                }}
                                                errorMessage={condition?.errorMessage}
                                            />
                                            {
                                                selectedTriggerParameter?.unit && selectedTriggerParameter?.unit != 'NA' && <div className='advance__rule__engine__trigger__condition-value-unit-container'>
                                                    {selectedTriggerParameter?.unit}
                                                </div>
                                            }
                                        </div>
                            }
                        </div>
                    }
                </div>
                <div className='advance__rule__engine__checkboxes__container'>
                    {
                        !condition?.isDerived && !condition?.isTriggerParamTypeEnum && !condition?.isTriggerParamTypeDate && <div className='advance__rule__engine__arithmetic__condition-toggle'>
                            <div className='advance__rule__engine__arithmetic__condition-toggle-btn' onClick={
                                () => {
                                    if(!selectedTriggerParameter || isEnumType(selectedTriggerParameter?.fieldType) || getFieldType(selectedTriggerParameter?.dataType) === 'date' || condition?.isDerived)return;
                                    toggleArithmeticCondition(!enableArithmeticLogic)
                                }}
                                >
                                <CheckBox
                                    checked={enableArithmeticLogic}
                                    isDisabled={!selectedTriggerParameter || isEnumType(selectedTriggerParameter?.fieldType) || getFieldType(selectedTriggerParameter?.dataType) === 'date' || condition?.isDerived}
                                />
                            </div>
                            <div className='advance__rule__engine__arithmetic__condition-toggle-label'>
                                Arithmetic Logic
                            </div>
                        </div>
                    }
                    {
                        condition?.triggerParamLevel==='CONNECTOR' && <div className='advance__rule__engine__arithmetic__condition-toggle'>
                            <div className='advance__rule__engine__arithmetic__condition-toggle-btn' onClick={
                                () => {
                                   if(!selectedTriggerParameter || condition?.triggerParamLevel!=='CONNECTOR')return;
                                   const data = cloneDeep(condition);
                                   data.connectorScope = condition.connectorScope === 'all' ? 'any' : 'all';
                                   handleConditionUpdate(data?.triggerCondName, data);
                                }}
                                >
                                <CheckBox
                                    checked={condition?.connectorScope === 'all'}
                                    isDisabled={!selectedTriggerParameter || condition?.triggerParamLevel!=='CONNECTOR'}
                                />
                            </div>
                            <div className='advance__rule__engine__arithmetic__condition-toggle-label'>
                                Check for all connectors
                            </div>
                        </div>  
                    }
                </div>
                <div className='advance__rule__engine__arithmetic__condition__body-container'>
                    {
                        enableArithmeticLogic && <div className='advance__rule__engine__arithmetic__condition__body'>
                            <div className='advance__rule__engine__arithmetic__condition-parameter-container'>
                                <div className='advance__rule__engine__arithmetic__condition-parameter-type'>
                                    <CustomDropDown
                                        selectDropDownId={'advance-rule-engine-arithmetic-parameter-type-dropdown'}
                                        dropDownClassName={'advance__rule__engine__arithmetic__parameter-type-dropdown-compact'}
                                        selectedValue={arithmeticParamType}
                                        selectOptions={parameterTypeList?.filter(item => item?.id === 'STATUS' || item?.id === 'SETTING')}
                                        renderToBody={true}
                                        handleSelectOptionChange={
                                            (value) => {
                                                if (value?.id != arithmeticParamType?.id) {
                                                    const data = cloneDeep(condition);
                                                    data.arithmeticParamId = null;
                                                    data.arithmeticParamLabel = null;
                                                    data.arithmeticParamLevel = null;
                                                    data.arithmeticParamType = null;
                                                    data.arithmeticParamValue = null;
                                                    data.arithmeticOperator = null;
                                                    data.errorMessageArithmeticParam = null;
                                                    data.arithmeticParamUnit = null;
                                                    data.arithmeticParamConnectorType = null;

                                                    setSelectedArtihmeticParameter(null);
                                                    handleConditionUpdate(data.triggerCondName, data);
                                                }
                                                setArithmeticParamType(value);
                                            }
                                        }
                                    />
                                </div>
                                <div className='advance__rule__engine__arithmetic__condition-parameter'>
                                    <SelectDropDown
                                        selectDropDownId={'advance__rule__engine__arithmetic__condition-parameter'}
                                        selectValue={selectedArithmeticParameter}
                                        handleSelectOptionChange={
                                            (value) => {
                                                const data = cloneDeep(condition);
                                                data.arithmeticParamId = value?.parameterKey;
                                                data.arithmeticParamLabel = value?.label;
                                                data.arithmeticParamLevel = value?.parameterLevel;
                                                data.arithmeticParamType = value?.parameterType;
                                                data.arithmeticParamUnit = value?.unit && value?.unit != 'NA' ? value.unit : null;
                                                data.arithmeticParamConnectorType = value?.parameterLevel === 'CONNECTOR' ? value?.acOrDcParam : null
                                                data.errorMessageArithmeticParam = null;
                                                setSelectedArtihmeticParameter(value);
                                                handleConditionUpdate(data.triggerCondName, data);
                                            }
                                        }
                                        renderToBody={true}
                                        selectOptions={parameterRef?.current?.filter(item => item?.parameterType === arithmeticParamType?.id && !isEnumType(item?.fieldType)) ?? []}
                                    />
                                </div>
                            </div>
                            <div className='advance__rule__engine__arithmetic__condition-operator'>
                                <SelectDropDown
                                    selectDropDownId='advance_rule_engine-arithmetic-operator-selection-dropdown'
                                    selectValue={arithmeticOperators?.filter(item => item.id === condition?.arithmeticOperator)?.[0] ?? null}
                                    handleSelectOptionChange={(value) => {
                                        const data = cloneDeep(condition);
                                        data.arithmeticOperator = value?.id;
                                        handleConditionUpdate(data?.triggerCondName, data);
                                    }}
                                    selectOptions={arithmeticOperators}
                                    renderToBody={true}
                                    isDisabled={!selectedArithmeticParameter}
                                />
                            </div>
                            <div className='advance__rule__engine__arithmetic__condition-value'>
                                <CustomInput
                                    inputValue={condition?.arithmeticParamValue ? condition?.arithmeticParamValue : ''}
                                    inputFieldId={'advance__rule__engine__arithmetic__condition-value'}
                                    isRequired={true}
                                    isDisabled={!condition?.arithmeticOperator}
                                    handleInputChange={(event) => {
                                        const error = checkValidationAndShowError('arithmeticParamValue', event?.target?.value, selectedArithmeticParameter!);
                                        const data = cloneDeep(condition);
                                        data.errorMessageArithmeticParam = error;
                                        data.arithmeticParamValue = event?.target?.value;
                                        handleConditionUpdate(data?.triggerCondName, data);
                                    }}
                                    errorMessage={condition?.errorMessageArithmeticParam}
                                />
                                {
                                    selectedArithmeticParameter && selectedArithmeticParameter?.unit != 'NA' && <div className='advance__rule__engine__trigger__condition-value-unit-container'>
                                        {selectedArithmeticParameter?.unit}
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
                {
                    showSessionNote && selectedParameters?.id === 'SESSION' && <div className='advance__rule__engine__consecutive__session__note'>
                        Note: Consecutive session logic can be defined using only a single &lsquo;Session Parameter&rsquo; condition.
                    </div>
                }
            </div>
        </div>
        <CustomChartPopup 
            show={showImage}
        >
            <img
                src={derivedConditionImageUrlRef?.current}
                alt='derived-condition-image'
                style={{
                display: derivedConditionImageUrlRef?.current ? 'block' : 'none',
                width: '100%',
                maxWidth: '800px',
                height: 'auto',
                borderRadius: '8px',
                scale: 0.75,
                }}
            />
            <IconButton
                    size="small"
                    onClick={() => { }}
                    sx={{
                        position: 'absolute',
                        right: '8px',
                        top: '8px',
                    }}
                >
                <CloseIcon
                    onClick={() => setShowImage(false)}
                    fontSize="small"
                    sx={{ color: '#000' }} 
                />
            </IconButton>
        </CustomChartPopup>
        </>
    )
}

export default CustomTriggerConditionComponent